import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Challenge from "./Challenge";
import TopicHeader from "./TopicHeader";

// Generate Order Data
function createData(name, statement, points, solved) {
  return { name, statement, points, solved };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  loader: {
    margin: theme.spacing(1),
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  root: {
    padding: "2px 4px",
    marginTop: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    width: "100%",
    backgroundColor: "#f5f5f5",
  },
}));

export function RelevantLinks({ links }) {
  if (links) {
    return (
      <Typography variant="body1">
        Relevant links:{" "}
        {links.map((link, index) => {
          let comma = ", ";
          if (index === links.length - 1) {
            comma = "";
          }
          return (
            <React.Fragment key={index} >
              <Link component="a" href={link.url}>
                {link.link}
              </Link>
              {comma}
            </React.Fragment>
          );
        })}
      </Typography>
    );
  }
  return <div />;
}

export default function Topic({
  name,
  topic,
  description,
  problems,
  links,
  solved,
    onSubmit,
  onSuccess,
  onFail,
}) {
  const classes = useStyles();
  const rows = [];
  for (let name in problems) {
    let c = problems[name];
    rows.push(
      createData(name, c.statement, c.points, solved && solved.has(name))
    );
  }
  return (
  <Grid item xs={12}>
    <Paper className={classes.paper} style={{ textAlign: "left", backgroundColor: "#f5f5f5"}}>
        <Grid container spacing={3} justify={"center"}>
          <Grid item xs={12}>
            <TopicHeader
                name={name}
                topic={topic}
                description={description}
                links={links}
                rows={rows}
                onSubmit={onSubmit}
                />
        </Grid>
        {rows.map((row) => (
          <Challenge
              key={row.name}
            name={row.name}
            topic={name}
              topicName={topic}
            statement={row.statement}
            points={row.points}
            solved={row.solved}
            onSuccess={onSuccess}
            onFail={onFail}
          />
        ))}
        </Grid>
      </Paper>
    </Grid>
  );
}
